import { withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["value", "onInput", "onKeydown", "onBlur", "onKeypress", "onPaste"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dp-wrap", _ctx.wrapperClass]),
    style: _normalizeStyle(_ctx.wrapperStyle)
  }, [
    _createVNode(_component_VueDatePicker, _mergeProps({
      "model-value": _ctx.innerValue,
      "auto-apply": _ctx.isMonthMode || !_ctx.enableTime,
      "close-on-auto-apply": _ctx.isMonthMode || !_ctx.enableTime,
      "month-picker": _ctx.isMonthMode,
      "enable-time-picker": !_ctx.isMonthMode && _ctx.enableTime,
      "enable-seconds": !_ctx.isMonthMode && _ctx.enableTime && _ctx.enableSeconds,
      format: _ctx.displayFormat,
      "input-class-name": _ctx.inputClass,
      "menu-class-name": _ctx.popupClass,
      "text-input": ""
    }, _ctx.passThroughAttrs, { "onUpdate:modelValue": _ctx.onUpdateFromPicker }), {
      "dp-input": _withCtx(({ onInput, onEnter, onTab, onBlur, onKeypress, onPaste, openMenu }) => [
        _createElementVNode("div", {
          class: "dp-field",
          role: "button",
          tabindex: "0",
          onClick: ($event: any) => (openMenu())
        }, [
          _createElementVNode("input", {
            class: _normalizeClass(["dp-input", _ctx.inputClass]),
            value: _ctx.displayText,
            readonly: "",
            "aria-readonly": "true",
            onInput: ($event: any) => (onInput($event)),
            onKeydown: [
              _withKeys(_withModifiers(($event: any) => (onEnter()), ["prevent"]), ["enter"]),
              _withKeys(($event: any) => (onTab()), ["tab"])
            ],
            onBlur: ($event: any) => (onBlur()),
            onKeypress: ($event: any) => (onKeypress($event)),
            onPaste: ($event: any) => (onPaste($event))
          }, null, 42, _hoisted_2),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "dp-icon",
            "aria-label": "Open calendar",
            tabindex: "-1"
          }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M7 3v2M17 3v2M4.5 8.5h15M6 6h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round"
              })
            ])
          ], -1))
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 16, ["model-value", "auto-apply", "close-on-auto-apply", "month-picker", "enable-time-picker", "enable-seconds", "format", "input-class-name", "menu-class-name", "onUpdate:modelValue"])
  ], 6))
}